module.exports = __webpack_public_path__ + "img/38.783664f1.svg";